import React, { Component } from 'react';
import { bool, string, object, arrayOf } from 'prop-types';
import classnames from 'classnames';

import FilterableTabs from 'elements/Tabs/FilterableTabs/FilterableTabs';
import { CardTypeA, CardTypeB } from './Cards';

import styles from './CardBanner.css';

class CardBanner extends Component {
  static propTypes = {
    title: string.isRequired,
    tabKey: string.isRequired,
    cards: arrayOf(object).isRequired,
    cardTypeB: bool,
    className: string
  }

  state = {
    size: 'l'
  }

  componentDidMount = () => {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    let size = 'l';

    if(window.innerWidth < 769) {
      size = 's';     
    } else if(window.innerWidth < 1025) {
      size = 'm';
    }

    this.setState({ size });
  }

  renderCardsTypeA = results => {
    const { className } = this.props;
    
    return (
      <ul className={classnames(styles.cardList, className)}>
        {results.map((item, i) =>
          <li key={`card-${i}`} className={styles.cardItem}>
            <CardTypeA {...item} />
          </li>
        )}
      </ul>
    );
  }

  renderCardsTypeB = results => {
    const { className } = this.props;

    return (
      <ul className={classnames(styles.cardList, className)}>
        {results.map((item, i) =>
          <li key={`card-${i}`} className={styles.cardItem}>
            <CardTypeB {...item} />
          </li>
        )}
      </ul>
    );
  };

  render() {
    const { title, cards, tabKey, cardTypeB, className } = this.props;
    const { size } = this.state;

    return (
      <section>
        <div className={className}>
          <h1 className={styles.title}>{title}</h1>
        </div>
        

        <FilterableTabs
          className={className}
          primaryKey={tabKey}
          items={cards}
          size={size}
          withoutLabels
        >
          {results => (
            cardTypeB
              ? this.renderCardsTypeB(results)
              : this.renderCardsTypeA(results)
          )}
        </FilterableTabs>
      </section>
    );
  }
}


export default CardBanner;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/CardBanner/CardBanner.js